// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html:root{--color: yellow}", "",{"version":3,"sources":["webpack://src/theme/Theme1/Theme1.module.scss"],"names":[],"mappings":"AAAA,UACE,eAAA","sourcesContent":["html:root {\n  --color: yellow;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
